// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panorama-modal .title-img[data-v-a0bba3e8]{width:150px;height:100px}.panorama-modal .no-img[data-v-a0bba3e8]{height:400px}", ""]);
// Exports
module.exports = exports;
